import React from 'react';
import { Modal, Input, Textarea, Body, Flex } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import { LabelListEdit } from 'components/LabelList/LabelListEdit';
import { ConsistencyCollectionView } from '../types';
import { useEditCollectionModal } from './useEditCollectionModal';

type EditCollectionModalProps = {
  visible: boolean;
  onClose: VoidFunction;
  collection: ConsistencyCollectionView | undefined;
  onCollectionUpdated: (
    id: string,
    params: { name: string; description: string; labels: string[] }
  ) => Promise<void>;
};

export const EditCollectionModal = ({
  visible,
  onClose,
  collection,
  onCollectionUpdated,
}: EditCollectionModalProps) => {
  const {
    name,
    handleNameChange,
    description,
    setDescription,
    labels,
    setLabels,
    submitting,
    nameError,
    handleSubmit,
  } = useEditCollectionModal({
    collection,
    visible,
    onClose,
    onCollectionUpdated,
  });

  return (
    <Modal
      title="Edit Consistency Collection"
      visible={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okDisabled={submitting}
      okText="Save"
      cancelText="Cancel"
      size="medium"
    >
      <FormContent direction="column" gap={16}>
        <Input
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => handleNameChange(e.target.value)}
          error={nameError}
        />

        <Textarea
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Flex direction="column" gap={6}>
          <Body size="medium" strong>
            Labels
          </Body>
          <LabelListEdit
            labels={labels}
            onChange={setLabels}
            disabled={submitting}
          />
        </Flex>
      </FormContent>
    </Modal>
  );
};

const FormContent = styled(Flex)`
  margin-top: 8px;
`;
